// import HomePopup from "components/1_Home/Home_components/HomePopup"
import { Outlet, useLocation } from 'react-router-dom'
import { useRecoilValue } from 'recoil'

import ApartPage from '@/features/apart/pages/ApartPage'
import { DoubleModal, FloatingBtn, Footer, Header, Loading, Modal } from '@/shared/components'
import { isLoading } from '@/shared/recoil/common/atom'

const Layout = () => {
  const visible = useRecoilValue(isLoading)
  const { pathname } = useLocation()
  return (
    <>
      {pathname.indexOf('b2b') > 0 ? (
        <>
          <ApartPage />
        </>
      ) : (
        <div className="base-layout">
          <Loading visible={visible} />
          {/* <HomePopup /> */}
          <Modal />
          <DoubleModal />
          <Header />
          <FloatingBtn />
          <Outlet />
          <Footer />
        </div>
      )}
    </>
  )
}
export default Layout
